module.exports = __webpack_public_path__ + "img/Tessellate16.6cf504aa.jpg";